import { linkify } from "./linkify/linkify.js";
const normalizeUrl = (url) => {
  const result = url && linkify.match(url) && linkify.match(url)?.[0];
  if (result && ["http:", "https:", ""].includes(result.schema)) {
    return result.url;
  }
  return null;
};
export {
  normalizeUrl
};
//# sourceMappingURL=normalize-url.js.map
